"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthorization = exports.AuthorizationContext = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("../hooks");
exports.AuthorizationContext = react_1.createContext(undefined);
var useAuthorization = function () { return react_1.useContext(exports.AuthorizationContext); };
exports.useAuthorization = useAuthorization;
var AuthorizationProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(), authorization = _b[0], setAuthorization = _b[1];
    var _c = react_1.useState(undefined), samlNameId = _c[0], setSamlNameId = _c[1];
    var isAccessDenied = hooks_1.useBoolean(false);
    return (react_1.default.createElement(exports.AuthorizationContext.Provider, { value: { value: authorization, set: setAuthorization, isAccessDenied: isAccessDenied, samlNameId: samlNameId, setSamlNameId: setSamlNameId } }, children));
};
exports.default = AuthorizationProvider;
